import { getRoutingProfiles } from "@/services/tech.service";
import { useQuery } from "@tanstack/react-query";

export const useRoutingProfiles = (enabled = true, options = {}) => {
  const queryKey = ["routing-profiles"];

  return useQuery({
    queryKey,
    queryFn: () => getRoutingProfiles(),
    enabled,
    ...options,
  });
};
